import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import useCardStyles from './Card.styles';
const Card = /*#__PURE__*/forwardRef(function Card(_ref, ref) {
  let {
      className,
      children
    } = _ref,
    restOfProps = _objectWithoutProperties(_ref, _excluded);
  const classes = useCardStyles();
  return /*#__PURE__*/React.createElement("div", Object.assign({}, restOfProps, {
    className: classNames('pds-card', classes.root, className),
    ref: ref
  }), children);
});
Card.propTypes = {
  /**
   * The content of the component.
   */
  children: node,
  /**
   * The CSS class name to apply to the card node.
   */
  className: string
};
export default Card;